import SearchForm from '@/js/components/forms/search_form';

const searchForm = document.getElementById('search-form');

if (searchForm) {
  // eslint-disable-next-line no-new
  new SearchForm(searchForm);
}
